"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgAmenityImmediateParking(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({}, props, {
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    className: "Icon ".concat(props.className ? props.className : ''),
    ref: svgRef
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.2 622.7c0 23-18.7 41.7-41.7 41.7-23 0-41.7-18.7-41.7-41.7 0-23 18.7-41.7 41.7-41.7 23 0 41.7 18.7 41.7 41.7zm-552-41.7c-23 0-41.7 18.7-41.7 41.7 0 23 18.7 41.7 41.7 41.7s41.7-18.7 41.7-41.7c0-23-18.7-41.7-41.7-41.7zm683.6 28.9v134.8c0 12.8-9.6 25.7-25.7 25.7h-67.4v80.2c0 12.8-9.6 25.7-25.7 25.7H795.9c-12.8 0-25.7-9.6-25.7-25.7v-80.2H420.4v80.2c0 12.8-9.6 25.7-25.7 25.7H285.6c-12.8 0-25.7-9.6-25.7-25.7v-80.2h-67.4c-16 0-28.9-9.6-25.7-25.7V609.9c0-57.8 35.3-105.9 86.7-125.2l48.1-9.6 12.8-16 28.9-86.7c16-54.6 64.2-86.7 118.7-86.7h269.6c54.6 0 102.7 35.3 118.7 86.7l28.9 86.7 12.8 16 48.1 9.6c51.6 19.3 86.9 67.4 83.7 125.2zM362.7 475.1h458.9l-28.9-86.7c-9.6-28.9-35.3-48.1-67.4-48.1h-80.2c0 12.8-9.6 25.7-25.7 25.7h-54.6c-12.8 0-25.7-9.6-25.7-25.7h-80.2c-32.1 0-57.8 19.3-67.4 48.1l-28.8 86.7zm6.4 295.3h-54.6V825h54.6v-54.6zm510.3 0h-54.6V825h54.6v-54.6zm93-160.5c0-44.9-35.3-80.2-80.2-80.2H298.5c-44.9 0-80.2 35.3-80.2 80.2V719h754.2V609.9zM202.2 247.2L134.8 321l-32.1-32.1c-6.4-6.4-16-6.4-22.5 0-6.4 6.4-6.4 16 0 22.5l41.7 41.7c3.2 3.2 6.4 3.2 9.6 3.2 3.2 0 6.4-3.2 9.6-3.2l83.4-83.4c6.4-6.4 6.4-16 0-22.5-6.3-6.4-15.9-6.4-22.3 0zm-48.1 205.4C67.4 452.6 0 382 0 298.6s67.4-150.8 154.1-150.8c83.4 0 150.8 67.4 154.1 150.8-.1 86.6-70.7 154-154.1 154zm121.9-154c0-67.4-54.6-122-122-122s-122 54.6-122 122 54.6 122 122 122 122-54.6 122-122z"
  }));
}

var ForwardRef = React.forwardRef(SvgAmenityImmediateParking);
var _default = ForwardRef;
exports.default = _default;